import { useState } from "react";
import { Ticket } from "lucide-react";
import DayOutingModal from "./DayOutingModal";

/**
 * Floating Action Button — bottom-left (WhatsApp/Call sit bottom-right) opens the Day Outing modal.
 * Terracotta orange matches the estate's accent palette.
 */
export default function DayOutingFAB() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid="day-outing-fab"
        onClick={() => setOpen(true)}
        aria-label="Book a 1-day farm outing"
        className="group fixed bottom-24 right-6 z-40 inline-flex items-center gap-2 bg-[#E11D48] hover:bg-[#C1123A] text-[#F2E7D0] px-5 py-3 shadow-lg shadow-black/40 font-mono-label text-xs tracking-[0.25em] uppercase transition-all duration-300 hover:scale-[1.04] hover:shadow-xl hover:shadow-black/60 md:bottom-24 md:right-6"
      >
        <Ticket size={16} className="shrink-0" />
        <span>Book Day Outing</span>
        <span className="absolute inset-0 bg-[#E11D48] animate-ping opacity-30 pointer-events-none" />
      </button>
      <DayOutingModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
